module.exports = __webpack_public_path__ + "static/agrafr2-0866dc80d9ac0a4b10d35c6672c865c9.png";